import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";


/**✅ getCategories */
export const getCategoriesThunk = createAsyncThunk(
    "fileCategories/getCategoriesThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getCategory") {
            if (state.fileCategories?.getCategories?.length > 0) {
                return state.fileCategories.getCategories;
            }
        }

        try {
            const response = await api.post(API_ROUTES.CATEGORYS, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Categories");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ getClients Thunk */
export const getFileClinetsThunk = createAsyncThunk(
    "fileCategories/getFileClinetsThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getClientLevelData") {
            if (state.fileCategories?.getCategories?.length > 0) {
                return state.fileCategories.getFileClients;
            }
        }

        try {
            const response = await api.post(API_ROUTES.CLIENTS, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Categories");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ getUsers Thunk */
export const getFileUsersThunk = createAsyncThunk(
    "fileCategories/getFileUsersThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getUserLevelData") {
            if (state.fileCategories?.getCategories?.length > 0) {
                return state.fileCategories.getFileUsers;
            }
        }
        try {
            const response = await api.post(API_ROUTES.USERS, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Categories");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ addCategory Thunk */
export const addCategoryThunk = createAsyncThunk(
    "fileCategories/addCategoryThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_CATEGORY, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Categoty Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);

/**✅ addFileUserLevel Thunk*/
export const addFileUserLevelThunk = createAsyncThunk(
    "fileCategories/addFileUserLevelThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_USER, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "User Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);

/**✅ addFileClientLevel Thunk */
export const addFileClientLevelThunk = createAsyncThunk(
    "fileCategories/addFileClientLevelThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_CLIENT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "User Adding failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);